import { ReactNode } from "react";

import css from "./chat.module.scss";

type ChatBodyWrapProps = {
  minimized: boolean;
  children: ReactNode;
};

export const ChatBodyWrap = ({ minimized, children }: ChatBodyWrapProps) => {
  if (minimized) {
    return null;
  }

  return <div className={css.bodyWrap}>{children}</div>;
};
